/* eslint-disable react/jsx-no-constructed-context-values */
import { createContext, ReactNode, useContext, useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { IPixAccountViewModel } from 'viewModels';
import { WalletController } from '../controller/WalletController';
import { useAuth } from './auth';

type PixAccountProps = {
  children: ReactNode;
};

type IInitialValues = {
  pixAccounts: IPixAccountViewModel[];
  setPixAccounts: React.Dispatch<React.SetStateAction<IPixAccountViewModel[]>>;
};

const PixAccountContext = createContext<IInitialValues>({} as IInitialValues);

const PixAccountProvider = ({ children }: PixAccountProps) => {
  const { user, tokenIsValid } = useAuth();
  const [pixAccounts, setPixAccounts] = useState<IPixAccountViewModel[]>([]);

  useQuery('pixAccounts', () => WalletController.getPixAccounts(user.id), {
    onSuccess: (data) => {
      if (!data || !data.length) return;
      setPixAccounts(
        data?.sort((a, b) => (a.isPreferred === b.isPreferred ? 0 : a.isPreferred ? -1 : 1)),
      );
    },
    refetchOnWindowFocus: false,
    enabled: !!user.id && tokenIsValid,
  });

  useEffect(() => {
    if (!tokenIsValid) {
      setPixAccounts([]);
    }
  }, [tokenIsValid]);

  return (
    <PixAccountContext.Provider
      value={{
        pixAccounts,
        setPixAccounts,
      }}>
      {children}
    </PixAccountContext.Provider>
  );
};

export default PixAccountProvider;

export const usePixAccounts = () => useContext(PixAccountContext);
